export enum MapLayerType {
  VECTOR = 'vector',
  VECTOR_GROUP = 'vectorGroup',
  GEOTIFF = 'geoTiff',
  GEOTIFF_GROUP = 'geoTiffGroup'
}
